import AnimatedPage from './AnimatedPage';
import Slider from '../components/slider';

/*
    Animation de la page Accueil
*/
class Home extends AnimatedPage{
    constructor(){
        super(0);

        this.showPage();

    }

    showPage(){
        let $h1 = $('h1'),
            $logo = $('h1 img'),
            $slider = $('.slider'),
            $firstSlide = $('.slider-text:first-child'),
            $firstVisuel = $('.slider-img:first-child'),
            $sliderDots = $('.slider-dots'),
            $footer = $('.SiteFooter'),
            h1Height = $h1.height()
        ;

        /* anim first slide*/
        let $surtitle = $('.s-cap2',$firstSlide),
            $title = $('h2',$firstSlide),
            $lieu = $('.lieu', $firstSlide),
            $button = $('.button',$firstSlide)
        ;


        TweenLite.set($h1,{autoAlpha:1});

        let tl = new TimelineLite()
        .set($slider,{className:'+=isActive'})
        .fromTo($firstVisuel,1,{scale:1,autoAlpha:0},{scale:1.2,autoAlpha:1,ease:Power4.easeOut,force3D:true})
        .add(this.showHeader(),1.5)
        .fromTo($logo, 0.9, {y:h1Height, autoAlpha:0}, {y:0, autoAlpha:1, ease:Power4.easeOut,force3D:true},'-=.4')
        .fromTo($surtitle,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},'-=.35')
        .fromTo($title,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},'-=.30')
        .fromTo($lieu,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},'-=.25')
        .fromTo($button,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut})
        .fromTo($sliderDots, 0.3,{y:30, autoAlpha:0},{y:0, autoAlpha:1, ease:Power4.easeOut,force3D:true,onStart:()=>{
            new Slider($('.slider'),{autoplay:true});
        }},'-=.30')
        // .fromTo($footer,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},.65)
    }

}
export default Home;
